import { combineReducers } from 'redux';

import {
    SET_SOCIAL_CONNECTED,
    SET_LOOKUP_LOADING,
    SET_AUTHENTICATION_REDIRECT_URL,
    SET_ENABLE_AUTH0_LOGIN_FOR_USER,
} from '../actions/lookup';

const socialConnected = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === SET_SOCIAL_CONNECTED) {
        nextState = payload;
    }
    return nextState;
};

const lookupLoading = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === SET_LOOKUP_LOADING) {
        nextState = payload;
    }
    return nextState;
};

const enableAuth0LoginForUser = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === SET_ENABLE_AUTH0_LOGIN_FOR_USER) {
        nextState = payload;
    }

    return nextState;
};

const auth0RedirectUrl = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === SET_AUTHENTICATION_REDIRECT_URL) {
        nextState = payload || '';
    }
    return nextState;
};

export default combineReducers({
    socialConnected,
    lookupLoading,
    enableAuth0LoginForUser,
    auth0RedirectUrl,
});
